import React from "react";
import { Link } from "react-router-dom";
import { Badge } from "antd";
import { useLocation } from "react-router-dom";

const FullName = (props) => {
  const {
    record,
    fetchStatus,
    customLocation,
    customUrlParam,
    extraDetail = "",
  } = props;
  let location = useLocation();
  const url = customLocation
    ? customLocation
    : location.pathname + "/" + record.id;
  const name = record.surename + " " + record.first_name + extraDetail;
  return fetchStatus ? (
    <Badge
      style={{ display: "flex", alignItems: "center" }}
      status={fetchStatus(record)}
      text={
        <Link
          style={{ color: "inherit", textDecoration: "underline" }}
          to={{
            pathname: url,
            state: customUrlParam,
          }}
        >
          <div className="content">{name}</div>
        </Link>
      }
    />
  ) : (
    <Link
      style={{ color: "inherit", textDecoration: "underline" }}
      to={{
        pathname: url,
        state: customUrlParam,
      }}
    >
      <div className="content">{name}</div>
    </Link>
  );
};

export default FullName;
